import { InjectionToken } from '@angular/core';

import type { IEnvironmentService } from './environment.interface';

export const EnvironmentService = new InjectionToken<IEnvironmentService>('EnvironmentService');
